class LocalStorage {
  static getItem(key, _default = null) {
    const item = localStorage.getItem(key);

    if (item === null) {
      return _default;
    }

    if (item.startsWith('{') || item.startsWith('[')) {
      return JSON.parse(item);
    }

    return item;
  }

  static setItem(key, item) {
    if (typeof item === 'object') {
      localStorage.setItem(key, JSON.stringify(item));
      return;
    }

    localStorage.setItem(key, item);
  }

  static removeItem(key) {
    localStorage.removeItem(key);
  }

  static saveLatestSearch(q) {
    const searchList =
      JSON.parse(localStorage.getItem('latestSearchList')) || [];
    if (searchList.length > 30) {
      searchList.pop();
    }
    searchList.map((search, i) => {
      if (search === q) {
        searchList.splice(i, 1);
      }
    });
    searchList.unshift(q);
    localStorage.setItem('latestSearchList', JSON.stringify(searchList));
  }
}

export default LocalStorage;



// WEBPACK FOOTER //
// ./src/app/utils/localStorage.js